import PropTypes from 'prop-types';

const initialValuesShape = PropTypes.shape({
  topic: PropTypes.string,
  text: PropTypes.string,
});

export { initialValuesShape };
